export const informations = {
  title: "Black Box Software Solutions",
  name: "Black Box",
  developer: "Suhaib Qanooni",
  slogan:
    "Much experience in Full-Stack Development | Database Management System | Software Maintenance",
  email: "blackboxsolutions2023@gmail.com",
  address: "1005, Kolola Pushta",
  city: "Kabul, Afghanistan",
  phone1: "+93 786 702 440",
  phone2: "+93 700 099 788",
  instagram: "https://instagram.com/suhaibqanooni/",
  twitter: "https://twitter.com/sqanooni/",
  facebook: "https://facebook.com/suhaibqanooni/",
  linkedin: "https://linkedin.com/suhaibqanooni/",
};

export const speakers = [
  {
    id: 1,
    image: "assets/img/speakers/suhaib1.jpeg",
    name: "Suhaib Qanooni",
    website: "https://suhaib-islam.netlify.app/",
    title: "Software Engineer",
    twitter: "/",
    facebook: "/",
    instagram: "/",
    linkedin: "/",
  },
  {
    id: 2,
    image: "assets/img/speakers/hhh.jpeg",
    name: "Hidayatul Haq Hidayat",
    website: "https://hhh-personal.netlify.app/",
    title: "Project Leader",
    twitter: "/",
    facebook: "/",
    instagram: "/",
    linkedin: "/",
  },
  {
    id: 3,
    image: "assets/img/speakers/asif.jpeg",
    name: "Muhammad Asif",
    website: "/",
    title: "Project Manager",
    twitter: "/",
    facebook: "/",
    instagram: "/",
    linkedin: "/",
  },
  {
    id: 4,
    image: "assets/img/speakers/noman.jpeg",
    name: "Noman Ahmadi",
    website: "/",
    title: "Database Developer",
    twitter: "/",
    facebook: "/",
    instagram: "/",
    linkedin: "/",
  },
  {
    id: 5,
    image: "assets/img/speakers/jan.jpeg",
    name: "Muhammad Jan",
    website: "/",
    title: "Finance Manager",
    twitter: "/",
    facebook: "/",
    instagram: "/",
    linkedin: "/",
  },
  {
    id: 6,
    image: "assets/img/speakers/seddiq.jpeg",
    name: "Seddiq Ullah",
    website: "/",
    title: "Human Resource Manager",
    twitter: "/",
    facebook: "/",
    instagram: "/",
    linkedin: "/",
  },
];
export const services = [
  {
    id: 1,
    title: "Software Engineering",
    description:
      " We develop accounting systems for the individual request of you business. Trust us in every decision.",
    icon: "bx bxl-dribbble",
    link: "/",
  },
  {
    id: 2,
    title: "Website Development",
    description:
      "Your Ecommerce Platform must also fully support the requirements of your business. Accounting, marketing, customer service, and other vital functions are absolutely necessary for the maintenance and continued growth of your business.",
    icon: "bx bx-file",
    link: "/",
  },
  {
    id: 3,
    title: "Mobile Application Development",
    description:
      "Black Box Software Solutions’ well-experienced developers are here to deliver an excellent website & Mobile App development service. Our services are available in Afghanistan, and anywhere else around the Globe.",
    icon: "bx bx-tachometer",
    link: "/",
  },
  {
    id: 4,
    title: "Database Administration",
    description:
      "Black Box Software Solutions’ well-experienced developers are here to deliver an excellent Database Solutions. Our services are available in Afghanistan, and anywhere else around the Globe.",
    icon: "bx bx-world",
    link: "/",
  },
  {
    id: 5,
    title: "Database Maintenance",
    description:
      " Black Box Software Solutions’ well-experienced database engineers are here to maintain your Database. Our services are available in Afghanistan, and anywhere else around the Globe.",
    icon: "bx bx-slideshow",
    link: "/",
  },
  {
    id: 6,
    title: "Project Management",
    description:
      " Black Box Software Solutions’ well-experienced Project  Management team is here to deliver an excellent project management planning. Our services are available in Afghanistan, and anywhere else around the Globe.",
    icon: "bx bx-arch",
    link: "/",
  },
];
export const skills = [
  {
    id: 1,
    image: "assets/img/Icons/react.png",
  },
  {
    id: 2,
    image: "assets/img/Icons/node.png",
  },
  {
    id: 3,
    image: "assets/img/Icons/MongoDB.png",
  },
  {
    id: 4,
    image: "assets/img/Icons/Expressjs.png",
  },
  {
    id: 5,
    image: "assets/img/Icons/php.png",
  },
  {
    id: 6,
    image: "assets/img/Icons/sql.png",
  },
];
export const portfolio = [
  {
    id: 1,
    image: "assets/img/App/app-1.jpg",
    title: "App 1",
    subTitle: "App",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-app",
  },
  {
    id: 2,
    image: "assets/img/App/01-Web.jpg",
    title: "Web 3",
    subTitle: "Web",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-web",
  },
  {
    id: 3,
    image: "assets/img/App/app-2.jpg",
    title: "App 2",
    subTitle: "App",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-app",
  },
  {
    id: 4,
    image: "assets/img/portfolio/portfolio-4.jpg",
    title: "Card 2",
    subTitle: "Card",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-card",
  },
  {
    id: 5,
    image: "assets/img/App/02-Web.jpg",
    title: "Web 2",
    subTitle: "Web",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-web",
  },
  {
    id: 6,
    image: "assets/img/App/app-3.jpg",
    title: "App 3",
    subTitle: "App",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-app",
  },
  {
    id: 7,
    image: "assets/img/portfolio/portfolio-7.jpg",
    title: "Card 1",
    subTitle: "Card",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-card",
  },
  {
    id: 8,
    image: "assets/img/portfolio/portfolio-8.jpg",
    title: "Card 3",
    subTitle: "Card",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-card",
  },
  {
    id: 9,
    image: "assets/img/App/04-Web.jpg",
    title: "Web 3",
    subTitle: "Web",
    link: "/portfolio-detailed.html",
    filter: "col-lg-4 col-md-6 portfolio-item filter-web",
  },
];
export const trainings = [
  {
    id: 1,
    title: "Web Designing",
    price: 300,
    activeCourses: ["HTML5", "CSS3", "Bootstrap4"],
    inactiveCourses: ["React.js", "Next.js"],
    link: "/",
    class: "col-lg-4 col-md-6",
    class2: "box",
  },
  {
    id: 2,
    title: "Full-Stack Development",
    price: 750,
    activeCourses: ["React.js", "Node.js", "Express", "MongoDB", "mySQL"],
    inactiveCourses: ["PostgreSQL", "MariaDB"],
    link: "/",
    class: "col-lg-4 col-md-6 mt-4 mt-md-0",
    class2: "box featured",
  },
  {
    id: 3,
    title: "Mobile Application Development",
    price: 400,
    activeCourses: [
      "React-Native",
      "IOS/Android",
      "Node.js",
      "APIs",
      "Other Liberaries",
    ],
    inactiveCourses: ["Flutter"],
    link: "/",
    class: "col-lg-4 col-md-6",
    class2: "box",
  },
];
export const sliderData = [
  {
    id: 1,
    name: "Suhaib Qanooni",
    title: "Software Engineer",
    image: "assets/img/hero-bg2.jpg",
    description:
      "Experienced in Full-Stack Development | DBMS & Information Systems | Software Engineering & Web Development",
  },
  {
    id: 2,
    name: "Hidayatul Haq Hidayat",
    title: "Project Leader",
    image: "assets/img/testimonials/hhh.jpeg",
    description:
      "Life may be a meandering path but don't worry about it, rather enjoy it. It is about the journey, not the destination so explore all that comes your way, learn and grow from it, for this journey only happens once.",
  },
  {
    id: 3,
    name: "Muhammad Asif",
    title: "Project Manager",
    image: "assets/img/testimonials/asif.jpeg",
    description: "Experienced in Project Management | Information Systems ",
  },
  {
    id: 4,
    name: "Noman Ahmadi",
    title: "Database Developer",
    image: "assets/img/testimonials/noman.jpeg",
    description:
      "Experienced in Node.js Development | DBMS & Information Systems ",
  },
  {
    id: 5,
    name: "Muhammad jan",
    title: "Finance Manager",
    image: "assets/img/testimonials/jan.jpeg",
    description:
      "Experienced in Finance | Economics & Information Management | Planning",
  },
  {
    id: 6,
    name: "Sediq Ullah ",
    title: "Human Resource",
    image: "assets/img/testimonials/seddiq.jpeg",
    description:
      "Experienced in Human Resource | Psychology | Strategy development",
  },
  {
    id: 7,
    name: "Kifayat Aziz ",
    title: "Junior Developer",
    image: "assets/img/testimonials/testimonials-5.jpg",
    description: "Experienced in HTML5,CSS3 | JavaScript | mySQL",
  },
  {
    id: 8,
    name: "Ahmad Abid ",
    title: "PHP Developer",
    image: "assets/img/testimonials/testimonials-4.jpg",
    description:
      "Experienced in HTML5,CSS3 | JavaScript & PHP | mySQL, MongoDB",
  },
  {
    id: 9,
    name: "Saif Salah ",
    title: "SQA Engineer",
    image: "assets/img/testimonials/Saif.jpeg",
    description:
      "Experienced in HTML5,CSS3 | JavaScript & PHP | mySQL, MongoDB",
  },
];
